import EventEmitter from 'methods/eventEmitter';
import Search from 'components/search-v2';
import SearchModal from 'components/search-modal';
import {isMobile} from 'methods/utils';
import Layout from 'components/layout';

let TopSearch;
if (isMobile()) {
    TopSearch = TopSearchMobile;
} else {
    TopSearch = TopSearchDesktop;
}

/**
 * Верхний поиск для мобилки
 */
function TopSearchMobile(options = {}) {
    // наследуемся
    EventEmitter.call(this);

    this._$openSearch   = document.querySelector('.js-openSearch');
    this._$citySearch   = this._$openSearch.querySelector('.js-citySearch');
    this._$periodSearch = this._$openSearch.querySelector('.js-periodSearch');
    this._$peopleSearch = this._$openSearch.querySelector('.js-peopleSearch');
    this._searchModal   = new SearchModal();
    this._search        = new Search(this._searchModal.$element.querySelector('.js-topSearchModal'), options);

    this._$openSearch.instance = this;

    // открытие модалки
    this._$openSearch.addEventListener('click', function() {
        this.open();
    }.bind(this));

    // открытие модалки поиска
    this.open = function() {
        return this._searchModal.open().then(() => this.emit('show'));
    }

    this.openDatePicker = function() {
        this._search.openDatePicker();
    }

    // рендер данных поиска на плашке
    this.renderPlate = function() {
        this._$citySearch.textContent   = this._search.getCitySearch();
        this._$periodSearch.textContent = this._search.getPeriodSearch();
        this._$peopleSearch.textContent = this._search.getPeopleSearch(options);
    }

    // событие change формы поиска
    this._search.on('change', (data) => {
        this.renderPlate();
        this.emit('search:change', data);
    });

    // событие submit формы поиска
    this._search.on('submit', (data) => {
        this.emit('search:submit', data);
    });

    // данные для поиска
    this.setData = function(data = {}) {
        this._search.setData(data);
        this.renderPlate();
    }

    // данные для поиска
    this.setSearchData = function(data) {
        this._search.setData(data);
        this.renderPlate();
    }

    // данные для поиска
    this.getSearchData = function() {
        return this._search.getData();
    }

    // данные формы поиска
    this.getFormData = function() {
        return new FormData(this._search._$form);
    }

    // кнопка поиска
    this._search.on('searchButton', function() {
        this._searchModal.close();

        // передаем дальше
        this.emit('searchButton');
    }.bind(this));

    // закрытия внутренних модалков
    this._search.on('hide', function() {
        // показываем внешнюю модалку, чтобы скролл не работал
        this._searchModal.open();
    }.bind(this));
}

/**
 * Верхний поиск для десктопа
 */
function TopSearchDesktop(options = {}) {
    // наследуемся
    EventEmitter.call(this);

    // для верх поиска
    this._$header            = document.querySelector('.js-header');
    this._$openSearch        = document.querySelector('.js-openSearch');
    this._$searchPlate       = document.querySelector('.js-searchPlate');
    this._$searchBlock       = document.querySelector('.js-searchBlock');
    this._$hideSeachBlock    = document.querySelector('.js-hideSeachBlock');

    // поля на плашке
    this._$citySearch   = this._$openSearch.querySelector('.js-citySearch');
    this._$periodSearch = this._$openSearch.querySelector('.js-periodSearch');
    this._$peopleSearch = this._$openSearch.querySelector('.js-peopleSearch');

    this._search = new Search();

    // показываем/скрываем верхний поиск
    this._toggleVisibility = function(visibility) {
        this._$header.classList.toggle('Header--search-modal', visibility);
        this._$searchPlate.classList.toggle('is-hidden', !visibility);
        this._togglePlateVisibility(visibility);
        Layout.scroll.setEnabled(visibility);
    }

    // показываем/скрываем плашку
    this._togglePlateVisibility = function(visibility) {
        if (visibility) {
            this._$searchBlock.style.opacity = '0';
            this._$searchBlock.classList.add('is-hidden');
        } else {
            this._$searchBlock.style.opacity = '';
            this._$searchBlock.classList.remove('is-hidden');
        }
    }

    // открытие модалки
    this._$openSearch.addEventListener('click', function() {
        this._toggleVisibility(true);

        this.emit('show');
    }.bind(this));

    // закрытие модалки
    this._hideEvent = function() {
        this._toggleVisibility(false);
    }

    // рендер данных поиска на плашке
    this.renderPlate = function() {
        this._$citySearch.textContent   = this._search.getCitySearch();
        this._$periodSearch.textContent = this._search.getPeriodSearch();
        this._$peopleSearch.textContent = this._search.getPeopleSearch();
    }

    // событие change формы поиска
    this._search.on('change', function() {
        this.renderPlate();

        // передаем дальше
        this.emit('change');
    }.bind(this));

    // данные для поиска
    this.setData = function(data = {}) {
        this._search.setData(data);
        this.renderPlate();
    }

    // кнопка поиска
    this._search.on('searchButton', this._hideEvent.bind(this));

    this._$header.addEventListener('click', function(e) {
        if (this._$header !== e.target) {
            return false;
        }

        e.preventDefault();
        e.stopPropagation();

        this._toggleVisibility(false);

        this.emit('hide');
    }.bind(this));

    /**
     * Скрыть/Показать поиск в шапке
     */
    if (this._$hideSeachBlock && this._$searchBlock) {
        window.addEventListener('scroll', function(e) {
            const top = this._$hideSeachBlock.getBoundingClientRect().top - 84;
            this._togglePlateVisibility(top > 0)
        }.bind(this));

        window.dispatchEvent(new Event('scroll'));
    }
}

// цепочка прототипов
TopSearch.prototype = Object.create(EventEmitter.prototype, {
    constructor: {
        value: TopSearch,
        enumerable: false,
        writable: true,
    }
});

export default TopSearch;
